<template lang="pug">
  lei-modal.challenge-modal(@close="toggleModal(false)" :title="title" size="sm" :close-with-overlay="false")
    .container
      input-creator(disabled :value="oldValue" label="Current value")
    .container(v-if="allowUnset")
      el-checkbox(label="Remove current value" v-model="isValueUnset")
    .container.column(v-show="!isValueUnset")
      el-checkbox.alternative-checkbox(v-if="allowAlternative" label="Alternative" v-model="needAlternative")
      input-creator(
        label="Propose new value"
        :autocompleteEntity="autocompleteEntity"
        :filter="filter"
        :data-type="type"
        :value="value"
        :disabled="isValueUnset"
        :class="{'error-input': !isValid}"
        @set-enum-value="setEnumValue"
        @set-range-value="setRangeValue"
        @set-input-value="setInputValue")
      p.error(v-if="isEmptyFlag") Value is required
      p.error(v-else-if="isSameValueFlag") New value cannot equal old
    .container(v-if="description")
      p.description {{description}}
    comment-input(@input="comment=$event" :required="isValueUnset")
    div(slot="footer")
      lei-btn(type="cyprus" fill @click="save" :disabled="disabled") Save
</template>
<script>
import InputCreator from '../lei-components/inputs/InputCreator'
import LeiModal from '../lei-components/LeiModal'
import LeiBtn from '../lei-components/LeiBtn'
import { mapState, mapMutations, mapActions, } from 'vuex'
import { TOGGLE_CHALLENGE_MODAL, SAVE_FIELD, } from '@/store/modules/record/modules/challenge/mutations-types'
import { findFilterById, prepareFilterForChallenge, } from '@/store/modules/search/helpers'
import { getAllowUnsetByPath, getAlternativeInputByPath, getExceptByPath, } from '@/utils/challenge'
import { getLabelForResource, } from '@/utils/resources'
import CommentInput from '@/components/lei-components/inputs/CommentInput'

const isArray = (arr) => Array.isArray(arr)
const isObject = (obj) => !isArray(obj) && typeof obj === 'object' && obj !== null

const validateResource = (oldVal, newVal) => {
  if (!oldVal) return oldVal === newVal
  else if (newVal.id && oldVal.id) return newVal.id === oldVal.id
  else if (newVal.code && oldVal.code) return newVal.code === oldVal.code
  else return newVal.code === oldVal
}
const validate = (oldVal, newVal) => oldVal ? oldVal === newVal : !!oldVal === !!newVal

export default {
  components: {
    CommentInput,
    LeiBtn,
    LeiModal,
    InputCreator,
  },
  data () {
    return {
      comment: {
        value: '',
        valid: true,
      },
      needAlternative: false,
      isEmptyFlag: false,
      isSameValueFlag: false,
      value: '',
      isValueUnset: false,
    }
  },
  computed: {
    description () {
      return this.challenge.text || null
    },
    type () {
      return this.needAlternative ? 'STRING' : this.challenge.type
    },
    autocompleteEntity () {
      return this.challenge.autocompleteEntity
    },
    jsonPath () {
      return this.challenge.jsonPath
    },
    fieldId () {
      return this.challenge.fieldId
    },
    allowAlternative () {
      return getAlternativeInputByPath(this.jsonPath)
    },
    allowUnset () {
      return this.challenge.oldValue && getAllowUnsetByPath(this.jsonPath)
    },
    exchange () {
      return this.challenge.exchange
    },
    except () {
      return getExceptByPath(this.jsonPath)
    },
    rawOldValue () {
      return this.challenge.oldValue
    },
    isValid () {
      return !this.isEmptyFlag && !this.isSameValueFlag
    },
    isSameValue () {
      if (this.autocompleteEntity) return this.rawOldValue.indexOf(this.value) !== -1
      return this.resource
        ? validateResource(this.rawOldValue, this.value)
        : validate(this.rawOldValue, this.value)
    },
    disabled () {
      let valueIsValid = this.isValueUnset || (this.value && !this.isSameValue)
      return !this.comment.valid || !valueIsValid
    },
    oldValue () {
      if (this.resource && isObject(this.rawOldValue)) return getLabelForResource(this.resource, this.rawOldValue)
      else if (isArray(this.rawOldValue)) return this.rawOldValue.join('; ')
      else return this.rawOldValue
    },
    title () {
      return `Challenge: ${this.challenge.title}`
    },
    filter () {
      let filter = findFilterById(this.filters, this.challenge.fieldId)
      return prepareFilterForChallenge({
        filter,
        oldValue: this.challenge.oldValue,
        exceptArray: this.except,
      })
    },
    resource () {
      return this.filter ? this.filter.resource : null
    },

    ...mapState('record/challenge', [ 'challenge', ]),
    ...mapState('search', [ 'filters', ]),
  },
  watch: {
    value () {
      if (!this.autocompleteEntity) this.isEmptyFlag = !this.value
      this.isSameValueFlag = this.isSameValue
    },
    needAlternative () {
      this.value = ''
    },
  },
  methods: {
    async save () {
      const field = await this.getField(this.exchange || this.fieldId)
      let fieldFormattedForStore = {
        original_value: this.challenge.oldValue,
        proposed_value: this.value,
        comment: this.comment.value,
        field: field.xpath,
        jsonPath: this.jsonPath,
      }
      if (this.isValueUnset) {
        fieldFormattedForStore.unsetValue = true
      }
      this.saveField(fieldFormattedForStore)
      this.toggleModal(false)
    },
    setInputValue ({ value, }) {
      this.value = value
    },
    setRangeValue ({ value, }) {
      this.value = value
    },
    setEnumValue ({ value, }) {
      this.value = value
    },

    ...mapMutations('record/challenge', {
      toggleModal: TOGGLE_CHALLENGE_MODAL,
      saveField: SAVE_FIELD,
    }),
    ...mapActions('record/challenge', [ 'getField', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .challenge-modal
    &.modal
      z-index 102

    .description
      text-align justify
      color $default-color
      line-height 1.25

    .el-form-item__content
      width 100%

    .alternative-checkbox
      margin-bottom 16px

  @media (min-width: $laptop)
    .challenge-modal
      .container
        margin-bottom 16px

        &:last-child
          margin-bottom 0

</style>



// WEBPACK FOOTER //
// src/components/modals/ChallengeModal.vue